import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 是否含税
 */
class IsIncludeTax extends UltMeta {
    /**
     * 不含
     */
    NO = new Meta(0, "不含");
    /**
     * 含税
     */
    YES = new Meta(1, "含税");
}

export const IS_INCLUDE_TAX = new IsIncludeTax();

/**
 * 税率
 */
class TaxRate extends UltMeta {
    /**
     * 3%
     */
    THREE = new Meta(1, "3%", 0.03);
    /**
     * 6%
     */
    SIX = new Meta(2, "6%", 0.06);
    /**
     * 9%
     */
    NINE = new Meta(3, "9%", 0.09);
    /**
     * 13%
     */
    THIRTEEN = new Meta(4, "13%", 0.13);
}

export const TAX_RATE = new TaxRate();

/**
 * 结算方式
 */
class SettlementMethod extends UltMeta {
    /**
     * 全部货款
     */
    FULL_PAYMENT = new Meta(1, "全部货款");
    /**
     * 支付定金
     */
    PAY_DEPOSIT = new Meta(2, "支付定金");
}

export const SETTLEMENT_METHOD = new SettlementMethod();

/**
 * 支付定金方式
 */
class DepositPaymentMethod extends UltMeta {
    /**
     * 货款比例
     */
    PAYMENT_RATIO = new Meta(1, "货款比例");
    /**
     * 固定金额
     */
    FIXED_AMOUNT = new Meta(2, "固定金额");
}

export const DEPOSIT_PAYMENT_METHOD = new DepositPaymentMethod();

/**
 * 商品状态
 */
class State extends UltMeta {
    UP_SHELF = new Meta(1, "上架");
    DOWN_SHELF = new Meta(2, "下架");
}

export const STATE = new State();

/**
 * 发布状态
 */
class PublishState extends UltMeta {
    /**
     * 待提交
     */
    PENDING = new Meta(6, "待提交");
    /**
     * 待审核
     */
    NOT_AUDIT = new Meta(1, "待审核");
    /**
     * 未通过
     */
    FAIL = new Meta(2, "未通过");
    /**
     * 已发布
     */
    PASS = new Meta(3, "已发布");
    /**
     * 已下架
     */
    DOWN_SHELF = new Meta(4, "已下架");
    /**
     * 已关闭
     */
    CLOSE = new Meta(5, "已关闭");
}

export const PUBLISH_STATE = new PublishState();

/**
 * 价格类型
 */
class CommodityPriceType extends UltMeta {
    /**
     * 固定价格
     */
    FIXED = new Meta(1, "固定价格");
    /**
     * 预估价格
     */
    ESTIMATED = new Meta(2, "预估价格");
}

export const COMMODITY_PRICE_TYPE = new CommodityPriceType();

/**
 * 等待支付时间
 */
class WaitingPaymentTime extends UltMeta {
    /**
     * 3小时
     */
    THREE_HOUR = new Meta(1, "3小时");
    /**
     * 12小时
     */
    TWELVE_HOUR = new Meta(2, "12小时");
    /**
     * 24小时
     */
    TWENTY_FOUR_HOUR = new Meta(3, "24小时");
    /**
     * 48小时
     */
    FORTY_EIGHT_HOUR = new Meta(4, "48小时");
    /**
     * 72小时
     */
    SEVENTY_TWO_HOUR = new Meta(5, "72小时");
    /**
     * 5天
     */
    FIVE_DAY = new Meta(6, "5天");
    /**
     * 7天
     */
    SEVEN_DAY = new Meta(7, "7天");
    /**
     * 不限时长
     */
    UNLIMITED = new Meta(8, "不限时长");
}

export const WAITING_PAYMENT_TIME = new WaitingPaymentTime();